
import { Cancel01Icon, Tick02Icon } from '@hugeicons/react'
import { Drawer } from 'vaul'

import { Button } from '@/shared/ui/Button'
import { QrCodeReader } from '@/shared/ui/QrCodeReader'

export const QrCodeReaderBottomSheet = ({
  title,
  open,
  status,
  onClose,
  onSuccess,
  successMessage = 'Check-in realizado com sucesso!'
}) => {
  return (
    <Drawer.Root open={open} onOpenChange={o => !o && onClose()} dismissible>
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 bg-black/40 z-sheet-backdrop" />
        <Drawer.Content className="fixed bottom-0 left-0 right-0 z-sheet flex flex-col bg-white rounded-t-2xl max-h-[92%] focus:outline-none">
          <Drawer.Handle className="mx-auto mt-3 mb-2 w-10 h-1 rounded-full bg-gray-300 shrink-0" />

          <div className="px-6 pb-3 border-b border-gray-100 shrink-0">
            <h1 className="flex justify-center items-center text-xl font-bold text-gray-800">
              {title}
            </h1>
          </div>

          <div className="p-6 overflow-y-auto flex-1">
            <div className="p-1 border-2 border border-gray-300 rounded-2xl">
              {status === 'success' && (
                <div className="overflow-hidden aspect-square rounded-2xl bg-gray-100 flex items-center justify-center">
                  <Tick02Icon variant="solid" className="text-success" size={64} />
                </div>
              )}
              {status !== 'success' && open && (
                <QrCodeReader
                  className="overflow-hidden aspect-square rounded-2xl"
                  onSuccess={onSuccess}
                  disabled={status === 'loading' || status === 'success'}
                />
              )}
            </div>

            {status === 'error' && (
              <div className="mt-3 rounded-xl px-4 py-3 bg-red-50 text-red-700 font-semibold text-sm">
                Ocorreu um erro, tente novamente apontando a câmera para o QR Code.
              </div>
            )}
            {status === 'success' && (
              <div className="mt-3 rounded-xl px-4 py-3 bg-green-50 text-green-700 font-semibold text-sm">
                {successMessage}
              </div>
            )}
          </div>

          <div className="flex gap-6 px-6 pb-6 pt-3 border-t border-gray-100 shrink-0">
            <button
              onClick={onClose}
              className="shrink-0 flex items-center justify-center w-10 h-10 rounded-[0.625rem] bg-gray-100 text-gray-700 border-0 cursor-pointer hover:bg-gray-200"
            >
              <Cancel01Icon size={20} variant="duotone" />
            </button>
            {status === 'success' ? (
              <Button variant="success" onClick={onClose} showTrailingIcon={false} className="grow">
                Fechar
              </Button>
            ) : (
              <span className="inline-flex items-center justify-center grow h-[var(--btn-h-md,44px)] px-[var(--btn-px-md,18px)] rounded-[var(--btn-r-md,12px)] text-[var(--btn-fs-md,0.875rem)] font-[var(--btn-fw-md,600)] text-white bg-[linear-gradient(180deg,#ffb74d_0%,#ff9800_100%)] text-center">
                Mantenha a câmera apontada
              </span>
            )}
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
}
